$(document).ready(function () {
  $("a.fancyimage").fancybox();
});

$(window).on('load', function () {
  var $preloader = $('#page-preloader'), $spinner = $preloader.find('.spinner');
  $spinner.fadeOut();
  $preloader.delay(350).fadeOut('slow');
});


if (Cookies.get('assist_view') != 'on') {
  $('.header-bg ul.nav > li').hover(function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn();
  }, function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut();
  });
}

var sender = function () {

  this.form;

  this.init = function (options) {

    this.options = options || {}

    if (!this.options.selector) {
      return false;
    }

    this.form = $(this.options.selector);

    this.addListeners();
  }


  this.addListeners = function () {
    this.form.on('submit', this, this.onSubmit);
  }

  this.onSubmit = function (scope) {

    var scope = scope.data;
//    console.log(this);
//    console.log(scope);

    var form = scope.form;
    var data = form.serialize();

    var btn_spinner = form.find('button[type="submit"]>i');
    var btn_span = form.find('button[type="submit"]>span');

    btn_span.hide();
    btn_spinner.show();

    $.ajax({
      "url": "/assets/components/modxsite/connectors/connector.php",
      "data": data,
      "type": "post",
      "dataType": "json",
      "success": function (response) {
        if (!response.success) {
          btn_spinner.hide();
          btn_span.show();
          $.jGrowl(response.message || "Произошла ошибка", {sticky: false, theme: 'error-jGrowl'});

          //console.log(response);

          if (response.total > 0) {
            for (i = 0; i < response.total; i++) {

              $("#" + response.data[i].id).addClass("has-error");
              // $("#"+response.data[i].id).attr("title",response.data[i].msg);


            }
          }
          return;
        }
        btn_spinner.hide();
        btn_span.show();

        $.jGrowl(response.message || "Ваш запрос успешно отправлен", {sticky: false, theme: 'success-jGrowl'});
        form[0].reset();

        $('#b-feedback').modal('hide');

        if (scope.options.autoclose) {
          form.hide('slow');
        }
      },
      "error": function () {
        btn_spinner.hide();
        btn_span.show();
        $.jGrowl("Произошла ошибка при отправке запроса", {sticky: false, theme: 'error-jGrowl'});
      }
    });

    return false;
  }
};

new sender().init({
  "selector": '#contacts-form'
});

new sender().init({
  "selector": '#b-anketa'
});